"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_TYPE_SIZE = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})(AccountType || (exports.AccountType = AccountType = {}));
exports.ACCOUNT_TYPE_SIZE = 1;
//# sourceMappingURL=accountType.js.map